import { IOS_APP_STORE_URL } from "@/lib/appStoreLinks";
import { cn } from "@/lib/utils";

type AppStoreDownloadButtonProps = {
  className?: string;
  /** Optional override (e.g. TestFlight or locale-specific URL). */
  href?: string;
};

/**
 * Official-style App Store badge linking to the Kryajet iOS listing.
 */
export function AppStoreDownloadButton({
  className,
  href = IOS_APP_STORE_URL,
}: AppStoreDownloadButtonProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "inline-flex items-center gap-3 rounded-xl bg-foreground px-5 py-3 text-background",
        "shadow-sm transition-[transform,opacity] duration-150 ease-[var(--ease-out)]",
        "hover:opacity-90 active:scale-[0.97]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "motion-reduce:transition-none motion-reduce:active:scale-100",
        className,
      )}
      aria-label="Download Kryajet on the App Store"
    >
      <svg
        viewBox="0 0 24 24"
        className="h-8 w-8 shrink-0"
        aria-hidden="true"
        fill="currentColor"
      >
        <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 22C7.79 22.05 6.8 20.68 5.96 19.47C4.25 16.97 2.94 12.45 4.7 9.39C5.57 7.87 7.13 6.91 8.82 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" />
      </svg>
      <span className="flex flex-col items-start leading-none text-left">
        <span className="text-[10px] font-medium tracking-wide opacity-90">Download on the</span>
        <span className="mt-0.5 text-xl font-semibold tracking-tight">App Store</span>
      </span>
    </a>
  );
}
